module.exports = __webpack_public_path__ + "images/home/product/wechat-miniprogram-notification-detail-a1e8a88315cf133990e5fe55d657e0a4.png";